import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../../reducers/typings'
import {
  loadGeneralPreferences,
  loadGeneralPreferencesByType,
  saveGeneralPreferences,
  saveGeneralPreferencesBatch,
} from './api'
import { IUserPreferenceGeneralListItem } from './typings'

const userGeneralPreferences =
  createEntityAdapter<IUserPreferenceGeneralListItem>({
    selectId: (row) => row.type,
  })

export const initialState = userGeneralPreferences.getInitialState({
  status: 'idle' as 'idle' | 'loaded',
})

export const userPreferencesGeneral = createSlice({
  name: 'userPreferencesGeneral',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadGeneralPreferences.fulfilled, (state, { payload }) => {
      userGeneralPreferences.setAll(state, payload)
      state.status = 'loaded'
    })
    builder.addCase(
      loadGeneralPreferencesByType.fulfilled,
      (state, { payload }) => {
        userGeneralPreferences.setAll(state, payload)
      },
    )
    builder.addCase(saveGeneralPreferences.fulfilled, (state, { payload }) => {
      userGeneralPreferences.upsertOne(state, payload)
    })
    builder.addCase(
      saveGeneralPreferencesBatch.fulfilled,
      (state, { payload }) => {
        userGeneralPreferences.upsertMany(state, payload)
      },
    )
  },
})

export default userPreferencesGeneral.reducer

export const { selectAll: userGeneralPreferencesList } =
  userGeneralPreferences.getSelectors(
    (state: StoreData) => state.userPreferencesGeneral,
  )

export const selectUserPreferencesGeneralLoaded = (state: StoreData) =>
  state.userPreferencesGeneral.status === 'loaded'
